<template>
  <div class="platforminfo">
    <div class="title">产品介绍</div>
    <div class="image-platforminfo">
      <img src="../../images/platforminfo.png" alt="">
    </div>
    <div class="til">产品特点</div>
    <div class="text-content">
      飞译CAT是一款智能辅助翻译系统，具备多语言多格式机器翻译、项目管理、个性化任务分配、语料库管理、团队管理、译后编辑等常用的人机辅助功能。先进的算法支持多种格式的文档解析处理、自动去重、自动锁定等，为译后编辑提供有力的译前保障；强大的多语机器翻译引擎结合翻译记忆库和术语库使翻译者的译后编辑更加轻松和高效；个性化的项目设置和管理流程可提高团队的协作能力和效率。特别针对高校的业务场景，系统还具备考试管理、测试管理、自动评分、人工评分、实习认证等功能，为高校的教学、科研、学生实践、社会服务提供有力的平台支撑。
    </div>
    <div class="til">平台优势</div>
    <div class="icon-list">
      <div class="icon-list-item">
        <div class="title-top">
          <img class="title-img" src="../../images/platforminfo_1.png" alt="">
          <span class="title-text">丰富的语言资源</span>
        </div>
        <div class="text-tips">数亿级别的平行语料库，覆盖50+个语种，多个细分领域。</div>
      </div>
      <div class="icon-list-item">
        <div class="title-top">
          <img class="title-img" src="../../images/platforminfo_2.png" alt="">
          <span class="title-text">快速的迁移能力</span>
        </div>
        <div class="text-tips">专业的语料加工，精准的知识挖掘，丰富的开发经验。</div>
      </div>
      <div class="icon-list-item">
        <div class="title-top">
          <img class="title-img" src="../../images/platforminfo_3.png" alt="">
          <span class="title-text">完备的基础算法</span>
        </div>
        <div class="text-tips">多语言词法分析、句法分析、语义分析工具，聚类、分类工具，自动摘要、信息检索工具。</div>
      </div>
      <div class="icon-list-item">
        <div class="title-top">
          <img class="title-img" src="../../images/platforminfo_4.png" alt="">
          <span class="title-text">先进的技术框架</span>
        </div>
        <div class="text-tips">基于神经网络的机器翻译框架与预训练语言模型的分析算法。</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlatFormInfo'
}
</script>

<style lang="less" scoped>
.platforminfo {
  width: 100%;
  height: 100%;
  .title {
    margin-bottom: 16px;
    font-size: 18px;
    color: #262c35;
  }
  .image-platforminfo {
    width: 100%;
    height: 400px;
    img {
      width: 100%;
      height: 400px;
      object-fit: scale-down;
    }
  }
  .til {
    position: relative;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #000000;
    &::after {
      width: 68px;
      height: 4px;
      background: linear-gradient(90deg, #0363f5 0%, #0078fc 100%);
      border-radius: 2px;
      position: absolute;
      bottom: -14px;
      left: 50%;
      transform: translateX(-50%);
      content: "";
    }
  }
  .text-content {
    padding: 16px;
    box-sizing: border-box;
    margin: 50px 0;
    min-height: 114px;
    font-size: 14px;
    color: #262c35;
    line-height: 22px;
    background: #f8f8f8;
    border-radius: 4px;
    text-align: left;
  }
  .icon-list {
    margin: 50px 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    &-item {
      width: 49%;
      height: 112px;
      .title-top {
        text-align: center;
        line-height: 68px;
        .title-text {
          font-size: 18px;
          font-weight: bold;
          color: #0078fc;
        }
      }
      .text-tips {
        // width: 49%;
        height: 37px;
        // text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 65px;
      }
    }
  }
}
</style>